<app-bot [subPage]="'vla'"></app-bot>